"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TagManager = _interopRequireDefault(require("../TagManager"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var removeCardCvv = function removeCardCvv(_a) {
  var api = _a.api,
      registeredUser = _a.registeredUser;

  _TagManager["default"].pushToDataLayer({
    event: 'removeCardCvv',
    ecommerce: {
      currencyCode: 'USD',
      add: {
        actionField: {
          list: 'cvvCheck'
        },
        api: api,
        registeredUser: registeredUser
      }
    }
  });
};

var _default = removeCardCvv;
exports["default"] = _default;